/**
 * Get the cart confirm view model
 *
 * @param state Redux state
 * @param product Targeted product
 * @param quantityRequested Quantity returned by the response
 * @param isForFamilyProduct Product being added to cart is a child of the base PDP product
 * @returns The confirm view model
 */
export function getConfirmViewModel(state, product, quantityRequested) {
    return {
        colorCode: product.productControls.colorCode,
        colorName: product.productControls.colorName,
        displayName: product.productMeta.displayName,
        imageId: product.productAddToCart.imageId,
        price: product.productMeta.price,
        size: product.productControls.sizeName,
        styleNumber: product.productMeta.styleNumber,
        imageStyle: product.productImageViewer.imageStyle,
        quantity: quantityRequested,
        primaryLabel: product.productAddToCart.primaryLabel,
        secondaryLabel: product.productAddToCart.secondaryLabel
    };
}
